module.exports = __webpack_public_path__ + "static/media/vegetarian.3a3b575d.svg";